import { Option } from '@cmg/common';

import { OfferingStatus, OfferingType } from '../../../graphql';

export const offeringTypeLabels: Record<OfferingType, string> = {
  [OfferingType.Ipo]: 'IPO',
  [OfferingType.IpoSpac]: 'IPO (SPAC)',
  [OfferingType.FollowOn]: 'Follow-on',
  [OfferingType.MarketedFo]: 'Marketed FO',
  [OfferingType.OvernightFo]: 'Overnight FO',
  [OfferingType.PrivatePlacement]: 'Private Placement',
  [OfferingType.RegisteredBlock]: 'Registered Block',
  [OfferingType.UnregisteredBlock]: 'Unregistered Block',
  [OfferingType.RegisteredDirect]: 'Registered Direct',
  [OfferingType.Rights]: 'Rights',
  [OfferingType.Convertible]: 'Convertible',
  [OfferingType.Abb]: 'ABB',
};

export const offeringTypesOptions = Object.keys(offeringTypeLabels).map<Option<OfferingType>>(
  type => ({
    label: offeringTypeLabels[type],
    value: type as OfferingType,
  })
);

export const offeringStatusLabels: Record<OfferingStatus, string> = {
  [OfferingStatus.Confidential]: 'Confidential',
  [OfferingStatus.Filed]: 'Filed',
  [OfferingStatus.Live]: 'Live',
  [OfferingStatus.Priced]: 'Priced',
  [OfferingStatus.Postponed]: 'Postponed',
  [OfferingStatus.Withdrawn]: 'Withdrawn',
  [OfferingStatus.Terminated]: 'Terminated',
};

export const IPO_OFFERING_TYPES = [OfferingType.Ipo, OfferingType.IpoSpac];

export const FOLLOW_ON_OFFERING_TYPES = [
  OfferingType.FollowOn,
  OfferingType.MarketedFo,
  OfferingType.OvernightFo,
  OfferingType.RegisteredBlock,
  OfferingType.UnregisteredBlock,
  OfferingType.RegisteredDirect,
  OfferingType.Rights,
  OfferingType.Abb,
];

export const CONVERTIBLE_OFFERING_TYPES = [OfferingType.Convertible];

export const BLOCK_OFFERING_TYPES = [OfferingType.RegisteredBlock, OfferingType.UnregisteredBlock];
